import type { ReactNode } from 'react';
import { GoalIcon, PenaltyGoalIcon, OwnGoalIcon, SubInIcon, SubOutIcon, CleanSheetIcon, RefereeCard } from '../../../components/ui/events';

const Chip = ({ icon, label }: { icon: ReactNode; label: string }) => (
  <span className="inline-flex items-center gap-1.5 rounded-full border border-[#e8ebf1] bg-white px-3 py-1.5 text-[12px] font-semibold text-slate-600">
    {icon}
    {label}
  </span>
);

export const MatchLegend: React.FC = () => {
  return (
    <div className="flex flex-wrap gap-2">
      <Chip icon={<GoalIcon />} label="Gol" />
      <Chip icon={<PenaltyGoalIcon />} label="Penalti (P)" />
      <Chip icon={<OwnGoalIcon />} label="Gol en propia (PP)" />
      <Chip icon={<RefereeCard color="yellow" />} label="Tarjeta amarilla" />
      <Chip icon={<RefereeCard color="red" />} label="Tarjeta roja" />
      <Chip icon={<SubInIcon />} label="Entra" />
      <Chip icon={<SubOutIcon />} label="Sale" />
      <Chip icon={<CleanSheetIcon />} label="Portería a cero (60+ min)" />
    </div>
  );
};
